import { artIcon } from '@/components/ui/app-icon';

// The Actions drawer's own icons: Cleanlist drawings in colour in the Candy
// style, Lucide icons in the text colour in the Plain style.
export const LinkedinLogoIcon = artIcon('linkedin');
export const CsvLogoIcon = artIcon('csv-logo');
export const ImportCrmIcon = artIcon('import-crm');
export const ImportCsvIcon = artIcon('import-csv');
export const ManualEntryIcon = artIcon('manual-entry');
export const CrmContactLookupIcon = artIcon('crm-contact-lookup');
export const ExportCsvIcon = artIcon('export-csv');
export const SyncCrmIcon = artIcon('sync-crm');
